import { css } from 'styled-components';
import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { innerBorder } from '@doltech/utils/lib/css-style';

export const colorStyles = css`
  background-color: ${colorsV2.black5};
  color: ${colorsV2.black80};

  &:hover {
    ${innerBorder(`2px solid ${colorsV2.gray20}`)};
  }

  &.active {
    background-color: ${colorsV2.primary5};
    color: ${colorsV2.primary100};
    ${innerBorder(`1px solid ${colorsV2.primary100}`)};
  }

  &.disabled {
    background-color: ${colorsV2.black5};
    color: ${colorsV2.black40};
    ${innerBorder('none')};
  }
`;
